import { env } from '@/config/env';
import { CvImportNotifications } from '@/features/cv-imports/components/CvImportNotifications';
import { can, useAccess } from '@/features/access/access';
import { NavLink, useLocation, useNavigate } from 'react-router';

import { ROUTES } from '@/app/router/routes';
import { Logo } from '@/components/brand/Logo';
import { useAuth } from '@/features/auth/context/auth-context';

import { HeaderSearch } from './HeaderSearch';
import { HeaderActionsOutlet } from './HeaderActions';
import { UserMenu } from './UserMenu';
import './Header.css';

export const Header = () => {
  const badges = {
    dev: ['DEV'],
    beta: ['BETA'],
    'dev-beta': ['DEV', 'BETA'],
    prod: [],
    stable: [],
    test: ['DEV'],
    'beta-test': ['DEV', 'BETA'],
  }[env.VITE_APP_CHANNEL];
  const access = useAccess();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const handleLogout = () => {
    void logout().then(() => navigate(ROUTES.login, { replace: true }));
  };

  return (
    <header className="platform-header">
      <div className="platform-header-surface">
        <div className="platform-header-brand-group">
          <NavLink
            to={ROUTES.dashboard}
            aria-label="ubeefy — Accueil"
            className="platform-header-brand"
          >
            <Logo />
          </NavLink>
          {badges.map((badge) => (
            <span
              key={badge}
              className={`platform-header-badge platform-header-badge--${badge.toLowerCase()}`}
            >
              {badge}
            </span>
          ))}
        </div>
        <HeaderSearch key={location.key} />
        <div className="platform-header-account">
          <HeaderActionsOutlet />
          {user && (can(access.data, 'candidates') || can(access.data, 'requirements')) && (
            <CvImportNotifications key={user.id} />
          )}
          {user ? (
            <UserMenu user={user} roleLabel={access.data?.role?.name} onLogout={handleLogout} />
          ) : null}
        </div>
      </div>
    </header>
  );
};
